import React from "react";
import { Link2, MessageCircle, Twitter } from "lucide-react";
import { toast } from "sonner";

export function ShareButtons({ title, path, className = "" }) {
  const url = `${window.location.origin}${path}`;
  const text = `${title} · Flavoria`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied"); }
    catch { window.prompt("Copy this link", url); }
  };
  const btn = "inline-flex items-center gap-2 h-11 px-4 rounded-full border border-border bg-white text-sm font-bold text-ink hover:border-coral hover:text-coral transition-colors";
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="share-buttons">
      <a className={btn} data-testid="share-whatsapp" target="_blank" rel="noreferrer" href={`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`}><MessageCircle size={16} className="text-leaf" /> WhatsApp</a>
      <a className={btn} data-testid="share-twitter" target="_blank" rel="noreferrer" href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`}><Twitter size={16} className="text-sky-500" /> Twitter</a>
      <button className={btn} data-testid="share-copy" onClick={copy}><Link2 size={16} /> Copy link</button>
    </div>
  );
}
